import { gql } from '@apollo/client';

export const FETCH_MODULES = gql`
  query findModules($where: ModuleWhereInput) {
    modules(where: $where, order: order_ASC) {
      edges {
        node {
          objectId
          name
          price_for_quantity
          included_quantity
          sku
        }
      }
    }
  }
`;
